import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import type { LucideIcon } from "lucide-react";
import { fadeUp, staggerContainer, viewportOnce } from "@/animations/motion";
import { ArrowUpRight } from "@/icons";

export interface RelatedLink {
  label: string;
  description?: string;
  to: string;
  icon: LucideIcon;
}

/** Grid of related service / industry links. */
export function RelatedLinks({ items }: { items: RelatedLink[] }) {
  return (
    <motion.div
      variants={staggerContainer(0.05)}
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3"
    >
      {items.map(({ label, description, to, icon: Icon }) => (
        <motion.div key={label} variants={fadeUp}>
          <Link
            to={to}
            className="group flex h-full items-center gap-4 rounded-2xl border border-border bg-card p-5 transition-all duration-300 hover:-translate-y-1 hover:border-primary/20"
          >
            <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
              <Icon className="h-5 w-5" />
            </span>
            <div className="min-w-0 flex-1">
              <p className="font-heading text-sm font-semibold text-foreground">{label}</p>
              {description && (
                <p className="truncate text-xs text-muted-foreground">{description}</p>
              )}
            </div>
            <ArrowUpRight className="h-4 w-4 text-muted-foreground transition-all group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-primary" />
          </Link>
        </motion.div>
      ))}
    </motion.div>
  );
}
